import { external as externalScript } from '../../utils/script'
import { getSite } from '../../application/pageDataObject'

function loadSocialMinerScript() {
  externalScript.load({
    name: 'socialMiner',
    loadNow: true,
  })
}

function loadReactfulScript() {
  externalScript.load({
    name: 'reactful',
    loadNow: true,
  })
}

export default function initEiExternalScripts() {
  if ('ei' === getSite()) {
    loadReactfulScript()
    loadSocialMinerScript()
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/initEiExternalScripts.js